const SignUpPage = (): JSX.Element => {
  return (
    <>
      <div>This is a SignUp Page.</div>
      <div>WIP: add sth here.</div>
      <div>Notice the Header and Footer is maintained.</div>
    </>
  );
};

export default SignUpPage;
